import styled from "styled-components";

export const TimerH2 = styled.h2`
  font-size:4rem;
`;
